export default __webpack_public_path__ + "static/media/Immagine_3.263fca49.jpg";